import './styles.scss'
import Link from 'next/link'

interface LinkButtonProps {
  href?: string
  type?: 'button' | 'submit' | 'reset'
  label: string
  external?: boolean
  name?: string
}

export const LinkButton = ({
  href,
  label,
  external = false,
  type = 'button',
  name = '',
}: LinkButtonProps) => {
  if (!href) {
    return (
      <button name={name} className="link-button" type={type}>
        {label}
      </button>
    )
  }

  return (
    <Link
      className="link-button"
      href={href}
      rel="noreferrer"
      target={external ? '_blank' : '_self'}
    >
      {label}
    </Link>
  )
}
